import { BrowserModule } from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';
import { AppComponent } from './app.component';
import {LoaderComponent} from './components/loader/loader.component';
import {LoaderService} from './components/loader/loader.service';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MDBBootstrapModulesPro, ToastModule} from 'ng-uikit-pro-standard';
import {AppRoutingModule} from './app-routing.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {SharedModule} from './modules/shared/shared.module';
import {ApplicationConfig} from './config/application.config';
import {ApiRoutes} from './config/api-routes';
import {LoggedInGuard} from './guards/logged-in.guard';
import {DashboardComponent} from './modules/dashboard/dashboard.component';
import {NavbarComponent} from './components/navbar/navbar.component';
import {DashboardMessagesCardComponent} from './modules/dashboard/components/dashboard-messages-card/dashboard-messages-card.component';
import {DashboardNotificationsPerBuildingCardComponent} from './modules/dashboard/components/dashboard-notifications-per-building-card/dashboard-notifications-per-building-card.component';
import {DashboardNotificationsCardComponent} from './modules/dashboard/components/dashboard-notifications-card/dashboard-notifications-card.component';
import {BuildingsService} from './modules/shared/service/buildings.service';
import {NgSelectModule} from '@ng-select/ng-select';
import { CookieService } from 'ngx-cookie-service';
import {GlobalErrorHandler} from './config/global-error-handler';
import { environment } from 'src/environments/environment';
import {LoggerService} from './service/logger.service';
import {TokenService} from './service/token.service';
import {Localization} from './modules/shared/enums/localization';
import {ChappsCommonAngularLibraryModule} from '@npm.chapps.com/chapps.common.angular.library';
import {ILocalization} from '@npm.chapps.com/chapps.common.angular.library/lib/interface/ILocalization';
import { LoginsService } from './modules/shared/service/logins.service';
import {FeatureService} from "./modules/shared/service/feature.service";
import {FeatureGuard} from "./modules/shared/service/FeatureGuard";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, environment.apiUrl + 'api/translations/', '.json');
}


@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
    DashboardComponent,
    NavbarComponent,
    DashboardMessagesCardComponent,
    DashboardNotificationsPerBuildingCardComponent,
    DashboardNotificationsCardComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({loader: {provide: TranslateLoader, useFactory: (createTranslateLoader), deps: [HttpClient]}}),
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    ToastModule.forRoot(),
    MDBBootstrapModulesPro.forRoot(),
    SharedModule.forRoot(),
    NgSelectModule,
    ChappsCommonAngularLibraryModule.forRoot(Localization as ILocalization, ApplicationConfig.PRIMARY_COLOR, ApplicationConfig.SECONDARY_COLOR),
  ],
  providers: [
    LoaderService,
    LoggerService,
    ApplicationConfig,
    ApiRoutes,
    LoggedInGuard,
    BuildingsService,
    TokenService,
    CookieService,
    LoginsService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }


